export const defaultScopeId = "v3.instance";
export const contextKey = "instance";

export const CURRENT_INSTANCE_REQUESTED = "INSTANCE/CURRENT_INSTANCE_REQUESTED";
export const CURRENT_INSTANCE_SUCCEEDED = "INSTANCE/CURRENT_INSTANCE_SUCCEEDED";
export const CURRENT_INSTANCE_FAILED = "INSTANCE/CURRENT_INSTANCE_FAILED";

// eslint-disable-next-line complexity, max-statements
export default (
    state = {
        currentInstance: null,
        errors: [],
        hasInitialData: false,
        loading: 0,
    },
    { type, data }
) => {
    switch (type) {
    case CURRENT_INSTANCE_REQUESTED: {
        ++state.loading;
        return state;
    }
    case CURRENT_INSTANCE_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.currentInstance = data;
        return state;
    }
    case CURRENT_INSTANCE_FAILED: {
        --state.loading;
        state.errors.push(data);
        return state;
    }
    default:
        return state;
    }
};

export const requestCurrentInstance = (data, resolve, reject) => ({ type: CURRENT_INSTANCE_REQUESTED, data, resolve, reject });
export const succeedCurrentInstance = data => ({ type: CURRENT_INSTANCE_SUCCEEDED, data });
export const failCurrentInstance = data => ({ type: CURRENT_INSTANCE_FAILED, data });

